var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinishStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 110,
    viewBox: "0 0 121 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.5 0L74.7566 41.8045H120.892L83.5677 67.6411L97.8244 109.446L60.5 83.6089L23.1756 109.446L37.4323 67.6411L0.10791 41.8045H46.2434L60.5 0Z",
    fill: "#726B6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinishStar);
export default __webpack_public_path__ + "static/media/finish-star.1e57cc820bdc64ab8dd5d0d12335188c.svg";
export { ForwardRef as ReactComponent };